import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const LoanHistoryLazy = lazyLoader(
  () => import('./LoanHistory' /* webpackChunkName: "loan-history" */),
);

const LoanHistory = () => {
  return (
    <Suspense fallback={null}>
      <LoanHistoryLazy />
    </Suspense>
  );
};

export default LoanHistory;
